import { render, staticRenderFns } from "./TemplateReportIkiSetSettingForm.vue?vue&type=template&id=71c08f88&"
import script from "./TemplateReportIkiSetSettingForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReportIkiSetSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports